import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../ActivityCalendar/formatDuration';

interface StatsStripProps {
  streakDays: number;
  todayActive: boolean;
  monthTotalMs: number;
  monthDaysKnit: number;
  /** True when the user has no lifetime activity — render faded, not absent. */
  muted: boolean;
}

interface ChipProps {
  value: React.ReactNode;
  label: string;
  soft?: boolean;
}

const Chip: React.FC<ChipProps> = ({ value, label, soft }) => (
  <div className="flex-1 rounded-2xl px-3 py-2 bg-primary-soft">
    <div className={`text-base font-black tabular-nums ${soft ? 'text-ink-faint' : 'text-ink'}`}>
      {value}
    </div>
    <div className="text-[10px] uppercase tracking-widest text-ink-faint">{label}</div>
  </div>
);

export const StatsStrip: React.FC<StatsStripProps> = ({
  streakDays,
  todayActive,
  monthTotalMs,
  monthDaysKnit,
  muted,
}) => {
  const { t } = useTranslation('session');
  return (
    <div
      data-testid="stats-strip"
      className={`flex gap-2 ${muted ? 'opacity-50' : ''}`}
    >
      <Chip
        value={
          <span>
            {streakDays}
            <span aria-hidden className="ml-0.5">🔥</span>
          </span>
        }
        label={t('home.stats.streak', 'day streak')}
        soft={!todayActive}
      />
      <Chip value={formatDuration(monthTotalMs)} label={t('home.stats.month', 'this month')} />
      <Chip value={monthDaysKnit} label={t('home.stats.daysKnit', 'days knit')} />
    </div>
  );
};
